export default __webpack_public_path__ + "static/media/logo-Growyx-white.886c8d31.svg";